if (!customElements.get('free-gift-item')) {  
  customElements.define("free-gift-item", class FreeGiftItem extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.currentVariant = null;
      this.gift_id = this.dataset.giftId;
      this.option_set = null;
    }

    connectedCallback() {
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
      if (document.readyState === 'complete') {
        this.products = JSON.parse(this.dataset.products.replaceAll('%27', '&apos;').replaceAll('%22', '&quot;'));
        this.atcButton = this.querySelector('[data-action="add-to-cart"]');
        this.imageWrapper = this.querySelectorAll('[data-product-images]');
        this.displayOptions = this.querySelector('[data-display-options]');
        this.selectedProduct = this.products.find(({ id }) => id === this.dataset.initialProduct);
        this.option_set = [...this.querySelectorAll('select[data-select]')].map(select => select.value);
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        this.addDelegatedEventListeners();
        return;
      }
      
      document.addEventListener('DOMContentLoaded', () => {
        this.products = JSON.parse(this.dataset.products.replaceAll('%27', '&apos;').replaceAll('%22', '&quot;'));
        this.atcButton = this.querySelector('[data-action="add-to-cart"]');
        this.imageWrapper = this.querySelectorAll('[data-product-images]');
        this.displayOptions = this.querySelector('[data-display-options]');
        this.selectedProduct = this.products.find(({ id }) => id === this.dataset.initialProduct);
        this.option_set = [...this.querySelectorAll('select[data-select]')].map(select => select.value);
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        this.addDelegatedEventListeners();
      });
    }

    populateSelectedProductOptions() {
      if (!this.displayOptions || !this.selectedProduct || !this.currentVariant) return;
      
      const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }) => {
        if (values.length < 1) return;
        return `
          <div class="flex items-center gap-[10px]">
            <strong class="text-xs uppercase">${name}</strong>
            <div class="flex items-center border border-secondaryDark !rounded-full pl-[15px]">
              <span aria-hidden="true" class="block h-2 w-2 rounded-full bg-primaryDark icon"></span>
              <select
                data-select
                class="
                  border-none
                  border-secondaryDark
                  !rounded-full
                  py-1
                  pl-[5px]
                  pr-[45px]
                  h-auto
                  text-xs
                  overflow-ellipsis
                  focus-visible:outline-none
                  swiper-no-swiping
                "
              >
                ${values.map((value) => {
                  const available = this.selectedProduct.variants.find(({ available, options }) => available && options.find((x) => x == value));
                  const select_value = this.currentVariant.options.find((x) => x === value)
                  return `
                    <option value="${value}" ${select_value ? 'selected' : ''} ${available ? '' : 'disabled' }>
                      ${value}
                    </option>
                  `
                }).join('')}
              </select>
            </div>
          </div>
        `
      }).join('')
      this.displayOptions.innerHTML = optionsHTMLString;

      const select = this.querySelector('[data-select]');
      this.addSelectListener(select);
    }
    
    addDelegatedEventListeners() {
      const select = this.querySelector('[data-select]');
      this.addSelectListener(select);

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
        } = clickedElement.dataset;
            
        let optionValue = null;
        if (clickedElement.closest('input[type="radio"]')) {
          optionValue = clickedElement.value;
        }
            
        switch (action) {
          case 'add-to-cart':
            const minicart = document.querySelector('mini-cart');
            minicart?.classList.add('loading');

            const data = {
              sections: [`${document.querySelector('mini-cart')?.dataset.sectionId}`],
              items: [{ 
                id: this.currentVariant?.id, 
                quantity: 1, 
                properties: { 
                  _free_gift: this.gift_id
                }
              }]
            };
            fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            })
              .then((response) => {
                return response.json();
              })
              .then((json) => {
                if (window.matchMedia('(max-width: 768px)').matches) document.querySelector('drawer-modal [data-drawer-action="close"]')?.click();
                setTimeout(() => {
                  document.querySelector('mini-cart')?.updateCartHtml(json);
                  document.querySelector('mini-cart')?.open();
                }, window.matchMedia('(min-width: 768px)').matches ? 0 : 501);
              })
              .finally(() => {
                minicart?.classList.remove('loading');
              })
              .catch(function(err) {
                minicart?.classList.remove('loading');
                console.error(err);
              });
            
          break;
          case 'next-slide':
            this.querySelector('swiper-carousel')?.slider.slideNext();
          break;
          case 'product-select': 
            const colorDisplay = this.querySelector('[data-display-color]');
            if (colorDisplay) colorDisplay.innerHTML = optionValue;
            this.selectedProduct = this.products.find((product) => product.color === optionValue.replaceAll(`'`, `&apos;`).replaceAll(`"`, `&quot;`));

            this.currentVariant = this.selectedProduct.variants
              .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
            
            if (this.querySelector('[data-display-price]')) {
              this.querySelector('[data-display-price]').innerHTML = this.selectedProduct.price_money;
            }
              
            this.imageWrapper.forEach((el) => {
              el.innerHTML = '';
            });
            
            if (this.selectedProduct?.featured_image) {
              this.imageWrapper.forEach((el) => {
                el.href = this.selectedProduct.url;
                el.innerHTML += `
                  <img src="${this.selectedProduct.featured_image}" alt="${this.selectedProduct.featured_image_alt}" width="400" class="object-cover w-[106px] aspect-[4/5] mix-blend-multiply" />
                `;
              });
            }
            
            this.enabledOrDisableAddToCartButton();
            this.populateSelectedProductOptions();
          break;
          default: break;
        }        
      });
    }

    addSelectListener(select) {
      select.addEventListener('change', () => {
        this.option_set = [...this.querySelectorAll('select[data-select]')].map(select => select.value);
        this.currentVariant = this.selectedProduct.variants
              .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));

        this.enabledOrDisableAddToCartButton();
      });
    }
    
    enabledOrDisableAddToCartButton() {  
      if (!this.atcButton) return;
      this.atcButton.innerHTML = `
        ADD GIFT
      `;
      if (this.currentVariant?.available) {
        this.atcButton.removeAttribute('disabled');
        return;
      }    
      
      this.atcButton.setAttribute('disabled', 'true');
    }
  });
}